import { TokenBalance } from "./Balance";
import { Network, Token } from "./Network";
import { extractErrorDetails } from "@/lib/balances/errorUtils";
import { classifyNodeError } from "@/lib/balances/nodeErrorClassifier";

export abstract class BalanceProvider {
    abstract supportsNetwork: (network: Network) => boolean
    abstract fetchBalance: (address: string, network: Network, options?: { timeoutMs?: number, retryCount?: number }) => Promise<TokenBalance[] | null | undefined>
    protected resolveTokenBalanceFetchError = (err: Error, token: Token, network: Network, isNativeCurrency?: boolean) => {
        console.error("balance_fetch_error", network.caip2Id, err)
        
        const errorDetails = extractErrorDetails(err);
        const category = classifyNodeError(err);
        
        const tokenBalance: TokenBalance = {
            network: network.caip2Id,
            token: token.symbol,
            amount: undefined,
            request_time: new Date().toJSON(),
            decimals: Number(token?.decimals),
            isNativeCurrency: isNativeCurrency ?? !token.contractAddress,
            error: {
                message: errorDetails.message,
                name: errorDetails.name,
                stack: errorDetails.stack,
                code: errorDetails.code,
                status: errorDetails.status,
                statusText: errorDetails.statusText,
                responseData: errorDetails.responseData,
                requestUrl: errorDetails.requestUrl,
                category: category
            }
        }

        return tokenBalance
    }
}
